import { z } from 'zod';
import { SortQuerySchema } from '../common';

export const RESULTADO_VISITA = ['NO_ENCONTRADO', 'VOLVERA', 'DEPOSITARA', 'PAGO', 'OTRO'] as const;
export type ResultadoVisita = (typeof RESULTADO_VISITA)[number];

export function fechaHoy(): string {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
}

export const CreateVisitaDtoSchema = z
  .object({
    idCliente: z.coerce.number().int(),
    resultado: z.enum(RESULTADO_VISITA),
    comentario: z.string().optional(),
    fecha: z
      .string()
      .optional()
      .default(() => fechaHoy()),
    /** GPS captured at the visit; absent for administrative registrations. */
    latitud: z.coerce.number().min(-90).max(90).optional(),
    longitud: z.coerce.number().min(-180).max(180).optional(),
  })
  .superRefine((value, ctx) => {
    if ((value.latitud === undefined) !== (value.longitud === undefined)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['latitud'],
        message: 'latitud and longitud must be provided together',
      });
    }
  });

export type CreateVisitaDto = z.infer<typeof CreateVisitaDtoSchema>;

export const QueryVisitasDtoSchema = z
  .object({
    offset: z.coerce.number().int().min(0).default(0),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    idCliente: z.coerce.number().int().optional(),
    idUsuario: z.string().uuid().optional(),
    fechaDesde: z.string().optional(),
    fechaHasta: z.string().optional(),
    resultado: z.enum(RESULTADO_VISITA).optional(),
  })
  .merge(SortQuerySchema);

export type QueryVisitasDto = z.infer<typeof QueryVisitasDtoSchema>;
